<template>
	<div class="page-content">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>智慧服务</el-breadcrumb-item>
			<el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage">投诉报表下载</span></el-breadcrumb-item>
			<el-breadcrumb-item>投诉数据库</el-breadcrumb-item>
		</el-breadcrumb>
		<section style="padding: 20px;margin-bottom: 10px;background-color: white;">
			<div class="title f16" style="font-size: 20px;font-weight: 600;margin: 16px 0 16px 0;">
				<span v-for="(item, i) in newPlateList" :key="i" :class="activeKey == item.dictCode ? 'active' : ''"
					@click="navChange(item)">{{ item.dictName }}</span>
			</div>

			<section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
				<el-form class="search-form" style="margin-left: -30px;">
					<el-form-item label="投诉单号" :label-width="formLabelWidth">
						<el-input v-model="complaintnumber" placeholder="请输入" clearable size="small"></el-input>
					</el-form-item>

					<el-form-item label="店铺名称" :label-width="formLabelWidth">
						<el-input v-model="shopname" placeholder="请输入" clearable size="small"></el-input>
					</el-form-item>

					<el-form-item label="所属平台" :label-width="formLabelWidth" v-if="activeKey == 'TB'">
						<el-select size="small" v-model="platform" placeholder="请选择平台">
							<el-option v-for="item in platforms" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="知识产权" :label-width="formLabelWidth">
						<el-input v-model="intellectualproperty" placeholder="请输入" clearable size="small"></el-input>
					</el-form-item>

					<el-form-item label="状态" :label-width="formLabelWidth">
						<el-select v-model="status" filterable placeholder="请选择" size="small" multiple>
							<el-option label="投诉成功" value="1"></el-option>
							<el-option label="投诉失败" value="2"></el-option>
							<el-option label="审核中" value="3"></el-option>
							<el-option label="商家处理中" value="4"></el-option>
							<el-option label="已撤诉" value="5"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="统计时间" :label-width="formLabelWidth">
						<el-date-picker v-model="searchformDate" type="daterange" start-placeholder="开始日期"
							end-placeholder="结束日期" range-separator="~" :picker-options="pickerOptions" size="small">
						</el-date-picker>
					</el-form-item>
					<el-form-item v-if="activeKey == 'TB'">
					</el-form-item>
					<el-form-item v-if="activeKey == 'TB'">
					</el-form-item>
					<el-form-item>
						<el-button size="small" class="search-btn" @click="getcomplaintdatanewcountal()">查询</el-button>
					</el-form-item>
				</el-form>
			</section>
		</section>
		<div style="background-color:#fff;padding: 20px">
			<div>
				<el-button type="primary" size="small" @click="downloadLinkNumByProduct" :loading="byProductLoading"
					style="margin-bottom: 8px;margin-top: 8px;margin-left: 4px;">下载数据</el-button>
				<el-button type="primary" size="small" @click="deleteChange">批量删除</el-button>
				<el-tag closable type="success" style="margin-left: 10px;" v-if="objType && objType == 3">
					<i class="el-icon-success" style="padding-right: 10px;"></i>
					投诉数据已完成
				</el-tag>
			</div>
			<div class="prompt">
				<i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
				共<span class="promptFont">{{ total }}</span>项,已选择<span class="promptFont">{{ openNumber }}</span>项
				<span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
				<span class="promptFont">/</span>
				<span class="promptFont2" @click="toggleSelection()">取消勾选</span>
			</div>

			<div class="g-margin-top">
				<el-table ref="multipleTable" :data="complaintDownloadList" style="width: 100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column type="index" label="序号" width="55">
					</el-table-column>
					<el-table-column label="投诉单号" prop="complaintnumber">
					</el-table-column>
					<el-table-column label="商品标题">
						<template slot-scope="scope">
							<el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.complaintlink"
								type="primary" target="_blank">
								{{ scope.row.itemtitle }}
							</el-link>
						</template>
					</el-table-column>
					<el-table-column label="店铺名称/旺旺">
						<template slot-scope="scope">
							<div v-if="scope.row.shopname" class="align_left ellipsis">{{ scope.row.shopname }}</div>
							<div v-else class="align_left ellipsis">/</div>
							<div v-show="scope.row.wangwang && scope.row.platform == 'TB' || scope.row.platform == '1688' || scope.row.platform == 'TM'"
								class="align_left ellipsis">{{ scope.row.wangwang }}</div>
							<div class="tall_icon">
								<img :src='require("@/assets/img/platform/pla_" + scope.row.platform + ".png")' alt
									class="edit_icon" />
								<ShopType style="margin-top: 8px;" :shoptype="scope.row.shoptype"
									v-if="scope.row.shoptype" />
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="状态">
					</el-table-column>
					<el-table-column prop="intellectualpropertytype" label="知识产权类型">
					</el-table-column>
					<el-table-column prop="complaintstime" label="投诉时间" width="200">
						<template slot-scope="scope">
							{{ scope.row.complaintstime | fullTime }}
						</template>
					</el-table-column>

				</el-table>
				<Pagination v-if="total > 0" class="pagination" :total="total" v-model="pagination"
					@onChange="getcomplaintdatanewcountal" />
			</div>
		</div>
		<!-- 批量删除 -->
		<el-dialog :visible.sync="deleteShow" width="360px" style="margin-top: 10%;" title="提示" id="dialog">
			<div style="display: flex;width: 100%;justify-content:center;">
				<i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
				<div>
					<div style="font-size: 16px;">你确认要删除{{ delType }}数据吗？</div>
					<div style="font-size: 14px;">删除后
						<span style="color: #e90e24;font-size: 14px;">删除数据将无法找回</span>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="onDeleteDownload()" size="small" :loading="allDelLoading">确
					定</el-button>
				<el-button @click="deleteShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取
					消</el-button>
			</div>
		</el-dialog>
		<!-- 批量删除 -->
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ShopType from "@/components/shopType";
import Pagination from 'components/pagination/pagination';

export default {
	components: {
		Pagination,
		ShopType
	},

	data() {
		return {
			objType: '',
			byProductLoading: false,
			delType: 0,
			allDelLoading: false,
			deleteShow: false,
			newPlateList: [{
				dictCode: "TB",
				dictName: "淘宝",
			}, {
				dictCode: "JD",
				dictName: "京东商城",
			}, {
				dictCode: "SN",
				dictName: "苏宁易购"
			}, {
				dictCode: "PDD",
				dictName: "拼多多"
			}, {
				dictCode: "DY",
				dictName: "抖音"
			}],
			activeKey: "",
			platforms: [
				{ value: 'TB', label: '淘宝' },
				{ value: 'TM', label: '天猫' },
				{ value: 'tmallhk', label: '天猫国际' },
				{ value: '1688', label: '1688' },
				{ value: 'XY', label: '闲鱼' },
				{ value: 'sc', label: 'Alibaba.com' },
				{ value: 'ae', label: 'Aliexpress' },
				{ value: 'sg', label: 'lazda' },
			],
			complaintnumber: '',
			shopname: '',
			intellectualproperty: '',
			status: [],
			formLabelWidth: "120px",
			platform: "TB",
			pagination: {
				current: 1,
				size: 10
			},
			total: 0,
			openNumber: 0,
			selectRows: [],
			complaintDownloadList: [],
			searchformDate: [],
			delIds: '',
			pickerOptions: {
				shortcuts: [{
					text: '今日',
					onClick: (picker) => {
						this.getRecentDate(picker, 1);
					}
				}, {
					text: '近7日',
					onClick: (picker) => {
						this.getRecentDate(picker, 7);
					}
				}, {
					text: '近15日',
					onClick: (picker) => {
						this.getRecentDate(picker, 15);
					}
				}, {
					text: '近30日',
					onClick: (picker) => {
						this.getRecentDate(picker, 30);
					}
				}, {
					text: '近90日',
					onClick: (picker) => {
						this.getRecentDate(picker, 90);
					}
				}, {
					text: '近365日',
					onClick: (picker) => {
						this.getRecentDate(picker, 365);
					}
				}]
			},
		}
	},

	methods: {
		// 时间范围
		getRecentDate(picker, n) {
			if (!n) {
				n = 90
			}
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
			if (picker) {
				picker.$emit('pick', [start, end]);
			}

			if (n === 1) {
				this.searchformDate[0] = end;
				this.searchformDate[1] = end;
			} else {
				this.searchformDate[0] = start;
				this.searchformDate[1] = end;
			}
		},
		// 勾选
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleAllSelection(row);
					this.openNumber = this.total
					this.checkAll = 2
				});
			} else {
				this.$refs.multipleTable.clearSelection();
				this.checkAll = 1
				this.openNumber = 0
			}
		},
		deleteChange() {
			console.log(this.selectRows)
			this.delIds = ''
			if (this.checkAll == 2) {
				this.delType = '全部'
				this.delIds = "checkAll"
			} else {
				this.delType = this.openNumber + '条'
				let arrIds = []
				for (let i in this.selectRows) {
					arrIds.push(this.selectRows[i].id)
				}
				this.delIds = arrIds.join(',')
			}
			if (this.delIds == '' || this.openNumber == 0) {
				this.$message({
					message: '没有选中项',
					type: 'warning'
				});
				return
			}
			this.deleteShow = true
		},
		onDeleteDownload() {
			this.allDelLoading = true
			let params = this.dataType()
			fetch({
				url: "hcm/HcmComplaintdatanew/deleteComplaintdatanew",
				method: "post",
				data: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				if (res.status == '10000') {
					this.$message.success('删除成功');
					this.deleteShow = false
					this.allDelLoading = false
					this.getcomplaintdatanewcountal()
				}
			})
		},
		// 下载
		downloadLinkNumByProduct() {
			this.byProductLoading = true
			let params = this.dataType()
			fetch({
				url: "hcm/HcmComplaintdatanew/downcomplaintdatanewcountal",
				method: "get",
				params: params,
				noFormat: true,
				responseType: "blob",
				timeout: 60 * 1000 * 5
			}).then(res => {
				//下载
				let url = window.URL.createObjectURL(new Blob([res]));
				let link = document.createElement("a");
				link.style.display = "none";
				link.href = url;
				link.setAttribute("download", "投诉数据库.xlsx");
				document.body.appendChild(link);
				link.click();
				this.byProductLoading = false
			});
		},
		onChangePage() {
			this.$router.push('/ComplaintReportDownload');
		},
		handleSelectionChange(val) {
			this.openNumber = val.length;
			this.selectRows = val;
		},
		dataType() {
			let params = {
				pageNo: this.pagination.current,
				pageSize: this.pagination.size,
			}
			if (this.searchformDate) {
				if (this.$options.filters['fullTime'](this.searchformDate[0]) == 'NaN-NaN-Na') {
					params.starttime = ''
				} else {
					params.starttime = this.$options.filters['fullTime'](this.searchformDate[0]);
				}
				if (this.$options.filters['fullTime'](this.searchformDate[1]) == 'NaN-NaN-Na') {
					params.endtime = ''
				} else {
					params.endtime = this.$options.filters['fullTime'](this.searchformDate[1]);
				}
			}
			if (this.complaintnumber) {
				params.complaintnumber = this.complaintnumber
			}
			if (this.shopname) {
				params.shopname = this.shopname
			}
			if (this.intellectualproperty) {
				params.intellectualproperty = this.intellectualproperty
			}
			if (this.status.length != 0) {
				params.status = this.status.join(',')
			}
			if (this.delIds) {
				params.ids = this.delIds
			}
			params.platform = this.platform
			return params
		},
		navChange(item) {
			this.activeKey = item.dictCode;
			this.platform = item.dictCode;
			//导航切换
			this.pagination.current = 1;
			this.pagination.size = 10;
			this.totalPage = 0;
			this.getcomplaintdatanewcountal();
		},
		getcomplaintdatanewcountal() {
			let params = this.dataType()
			fetch({
				url: "hcm/HcmComplaintdatanew/getcomplaintdatanewcountal",
				method: "post",
				params: params,
				noFormat: true,
				responseType: "text"
			}).then(result => {
				let res = JSON.parse(result);
				let { data } = res
				if (res.status == '10000') {
					this.complaintDownloadList = data.content
					this.objType = data.obj
					this.total = data.totalElements
				}
			})
		},
	},

	computed: {

	},

	created() {
		this.getRecentDate();
	},

	mounted() {
		this.activeKey = 'TB'
		this.getcomplaintdatanewcountal()
	},
}
</script>


<style lang='scss'>
$highColor: #108cee;

.download-btn {
	cursor: pointer;
	color: $highColor;
}

.prompt {
	height: 28px;
	border: 1px solid #108cee;
	background-color: #e6f7ff;
	border-radius: 5px;
	line-height: 28px;
	margin: 8px 0 0 0;
}

.promptFont {
	color: #108cee;
	font-size: 14px;
	margin-left: 3px;
	margin-right: 3px;
}

.promptFont2 {
	color: #108cee;
	font-size: 14px;
	margin-left: 3px;
	margin-right: 3px;
	cursor: pointer;
}

.pagination {
	margin-top: 20px;
	padding-right: 20px;
	text-align: right;
}

.notice-wrap {
	height: 32px;
	border-radius: 4px;
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	font-size: 12px;
	color: #333333;
	line-height: 32px;
	padding: 0 0 0 20px;

	i {
		font-size: 15px;
		color: $highColor;
		vertical-align: text-bottom;
	}

	span {
		color: $highColor;
		padding: 0 2.5px;
		cursor: pointer;
	}
}

.title {
	text-align: center;

	span {
		padding-left: 33px;
		cursor: pointer;
	}

	.span:hover,
	.active {
		color: #108cee;
	}
}

@import "style/activityApproval.scss";
@import "style/activityApprovalSetting.scss";
@import "style/activityDeclaration.scss";
</style>
